import {
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Box,
  Chip,
  Tooltip,
  IconButton,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import NavigationHeader from "../../../components/NavigationHeader";
import { Add as AddIcon, Visibility as ViewIcon } from "@mui/icons-material";
import InventoryActionModal from "./InventoryActionModal";
import { InventorySummary, InventoryCategory } from "./types";
import { tableHeaderStyles, tableCellStyles } from "../../../utils/styles";
import AddCategoryModal from "./AddCategoryModal";
import { useNavigate } from "react-router-dom";
import { categoryApi } from "./apiService";
import { Loading } from "../../../components/Loading";

const Inventory = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const navigate = useNavigate();
  const [inventorySummary, setInventorySummary] =
    useState<InventorySummary | null>(null);
  const [selectedCategory, setSelectedCategory] =
    useState<InventoryCategory | null>(null);
  const [addCategory, setAddCategory] = useState(false);
  const [categories, setCategories] = useState<InventoryCategory[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchCategories = async () => {
    try {
      setIsLoading(true);
      const categories = await categoryApi.getCategories();
      setCategories(categories);
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleViewDetails = (category: InventoryCategory) => {
    navigate(
      `/master-data/inventory/${category?.categoryName}/${category?.id}`
    );
    setSelectedCategory(category);
    // setViewDetailsOpen(true);
  };

  return (
    <Container maxWidth="lg" sx={{ py: 2 }}>
      <NavigationHeader
        breadcrumbs={[
          { label: "Master Data", path: "/master-data" },
          { label: "Inventory" },
        ]}
        title="Inventory"
        button={{
          label: "Add Category",
          onClick: () => setAddCategory(true),
          icon: <AddIcon />,
        }}
      />

      {/* Inventory Categories Table */}
      {isLoading ? (
        <Loading message="Loading inventory categories..." fullScreen={true} />
      ) : categories.length === 0 ? (
        <Typography variant="body1" sx={{ textAlign: "center", mt: 4 }}>
          No Inventory Information found
        </Typography>
      ) : (
        <TableContainer component={Paper}>
          <Table size="small" aria-label="inventory table">
            <TableHead>
              <TableRow>
                <TableCell {...tableHeaderStyles} sx={{ fontSize: "0.75rem" }}>
                  Category
                </TableCell>
                <TableCell
                  {...tableHeaderStyles}
                  align="center"
                  sx={{ fontSize: "0.75rem" }}
                >
                  Total Items
                </TableCell>
                <TableCell
                  {...tableHeaderStyles}
                  align="center"
                  sx={{ fontSize: "0.75rem" }}
                >
                  In Use
                </TableCell>
                <TableCell
                  {...tableHeaderStyles}
                  align="center"
                  sx={{ fontSize: "0.75rem" }}
                >
                  Available
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {categories.map((category) => (
                <TableRow
                  key={category?.categoryName}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                    "&:hover": { backgroundColor: "action.hover" },
                  }}
                >
                  <TableCell {...tableCellStyles}>
                    <Typography
                      variant="body2"
                      onClick={() => handleViewDetails(category)}
                      sx={{
                        cursor: "pointer",
                        textDecoration: "underline",
                        fontSize: "0.75rem",
                      }}
                    >
                      {category?.categoryName}
                    </Typography>
                  </TableCell>
                  <TableCell {...tableCellStyles} align="center">
                    <Typography variant="body2" sx={{ fontSize: "0.75rem" }}>
                      {category?.totalItems || 0}
                    </Typography>
                  </TableCell>
                  <TableCell {...tableCellStyles} align="center">
                    <Typography variant="body2" sx={{ fontSize: "0.75rem" }}>
                      {category?.totalInUse || 0}
                    </Typography>
                  </TableCell>
                  <TableCell {...tableCellStyles} align="center">
                    <Typography variant="body2" sx={{ fontSize: "0.75rem" }}>
                      {category?.totalAvailable || 0}
                    </Typography>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {/* <InventoryActionModal open={modalOpen} onClose={handleModalClose} /> */}

      {/* Details Modal */}
      {/* <InventoryActionModal 
        open={viewDetailsOpen} 
        onClose={handleViewDetailsClose}
        category={selectedCategory}
        viewMode={true}
      /> */}

      <AddCategoryModal
        open={addCategory}
        onClose={() => {
          setAddCategory(false);
        }}
        fetchCategories={fetchCategories}
      />
    </Container>
  );
};

export default Inventory;
